import { Component, ElementRef, HostListener, computed, effect, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FilterItem, SelectOption } from '../filter-component/filter-component.model';
import { LocalizePipe } from '../../pipes/LocalizePipe';


@Component({
  selector: 'app-gov-select-component',
  imports: [ LocalizePipe],
  templateUrl: './gov-select-component.html',
  styleUrl: './gov-select-component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GovSelectComponent),
      multi: true
    }
  ]
})
export class GovSelectComponent implements ControlValueAccessor {
  filterItem = input<FilterItem>();
  placeholder = input<string>('');
  options = input.required<SelectOption[]>();

  value = signal<string | number | null>(null);
  searchText = signal<string>('');
  isOpen = signal<boolean>(false);

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // text vybrané položky odvozený z aktuální hodnoty a načtených options
  selectedItemText = computed(() => {
    const val = this.value();
    if (val === null || val === undefined || val === '') {
      return '';
    }
    const match = this.options().find(o => o.value === val);
    return match ? match.text : '';
  });

  filteredOptions = computed(() => {
    const filterText = this.searchText().toLowerCase();

    // pokud je input prazdny nebo odpovida vybrane polozce, ukaze se vse
    if (filterText === '' || filterText === this.selectedItemText().toLowerCase()) {
      return this.options();
    }

    // jinak se filtruje
    return this.options().filter(o =>
      o.text.toLowerCase().includes(filterText)
    );
  });

  constructor(private eRef: ElementRef) {
    // pokud uživatel needituje (dropdown zavřený), zobrazí v inputu text vybrané položky;
    // reaguje i na asynchronní načtení options a na změny hodnoty z formuláře (reset, initialValues)
    effect(() => {
      const itemText = this.selectedItemText();
      if (!this.isOpen()) {
        this.searchText.set(itemText);
      }
    });
  }

  onInput(event: Event): void {
    this.isOpen.set(true);
    const target = event.target as HTMLInputElement;
    this.searchText.set(target.value);
  }

  selectOption(option: SelectOption): void {
    this.value.set(option.value);
    this.isOpen.set(false);
    this.onChange(option.value);
    this.onTouched();
  }

  openDropdown(): void {
    this.isOpen.set(true);
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }

  // Angular nám posílá data z formuláře (např. při resetu nebo načtení initialValues)
  writeValue(obj: any): void {
    this.value.set(obj ?? null);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  isControlFilled(): boolean
  {
    const value = this.searchText();

    if (value === null || value === undefined) {
      return false;
    }
    // kontrola prázdného stringu
    // (!!value převede string na boolean: '' -> false, 'abc' -> true)
    return !!value.toString().trim();
  }
}
